<template>
  <div class="container mt-4">
    <h2>Nova Compra</h2>
    <div class="top-menu">
      <BaseInputLogic
        style="margin-bottom: 13px"
        :options="menu.options"
        :value.sync="menu.value"
        @onDataChange="handleInputChange(menu.value)"
      ></BaseInputLogic>
    </div>

    <div v-if="menu.value == '1'">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col>
            <b-form-group label-for="code" label="Cód. Compra">
              <b-form-input
                v-model="purchase.code"
                type="text"
                id="code"
                required
              ></b-form-input> </b-form-group
          ></b-col>
          <b-col>
            <b-form-group label-for="supplier" label="Fornecedor">
              <b-form-select
                v-model="purchase.supplierId"
                :options="suppliers"
              ></b-form-select> </b-form-group
          ></b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label-for="date" label="Data do registro">
              <b-form-input
                v-model="purchase.date"
                type="date"
                id="date"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="costCenter" label="Centro de custo">
              <b-form-input
                v-model="purchase.costCenter"
                type="text"
                id="costCenter"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label-for="purchaseType" label="Tipo da despesa">
              <b-form-select
                v-model="purchase.purchaseTypeId"
                :options="purchaseTypes"
              ></b-form-select> </b-form-group
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="purchase.purchaseTypeId == 'new'">
          <b-col cols=1>
            <b-form-group label-for="priority" label="Prioridade">
              <b-form-input
                v-model="newPurchaseType.priority"
                type="number"
                id="priority"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="purchaseType" label="Cód. Tipo da despesa">
              <b-form-input
                v-model="newPurchaseType.code"
                type="text"
                id="costCenter"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="namePurchaseType" label="Nome Tipo da despesa">
              <b-form-input
                v-model="newPurchaseType.name"
                type="text"
                id="namePurchaseType"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-button
              variant="primary"
              class="mt-4"
              block
              @click="addNewPurchaseType"
            >
              Salvar
            </b-button>
          </b-col>
        </b-row>

        <hr />
        <h3>Itens da compra</h3>

        <b-row>
          <b-col label-for="product" cols="12">
            <b-form-group label="Produto/Serviço">
              <b-form-select
                v-model="emptyPurchaseProduct.productId"
                id="product"
                :options="itens"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Quantidade">
              <b-form-input
                v-model.number="emptyPurchaseProduct.quantity"
                type="number"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Valor Unitário">
              <b-form-input
                v-model.number="emptyPurchaseProduct.purchasePrice"
                type="number"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Desconto">
              <b-form-input
                v-model="emptyPurchaseProduct.discount"
                type="text"
                :max="discountType == '1' ? 100 : null"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="1">
            <b-form-group label-for="discountType" label="Tipo">
              <b-form-select
                v-model="discountType"
                id="discountType"
                :options="discountTypeOptions"
                type="text"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col >
            <b-form-group label="Valor Total">
              <b-form-input
                :value="calculatedTotal"
                type="text"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col >
            <b-button
              variant="primary"
              class="mt-4"
              block
              @click="addNewPurchaseType"
            >
              Salvar
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ag-theme-alpine-dark" style="height: 250px;">
            <ag-grid-vue
              style="width: 100%; height: 100%;"
              :columnDefs="columnDefs"
              :rowData="items"
              @grid-ready="onGridReady"
              @selection-changed="onSelectionChanged"
              @cell-value-changed="onCellValueChanged"
              :rowSelection="'multiple'"
              :defaultColDef="defaultColDef"
              rowHeight="40"
              :pagination="true"
            ></ag-grid-vue>
          </b-col>
        </b-row>

        <hr />
        <h3>Pagamento</h3>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Forma de pagamento">
              <b-form-select
                v-model="purchase.payment.paymentMethod"
                :options="paymentMethodsOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Conta pagamento">
              <b-form-select
                v-model="purchase.payment.bankAccount"
                :options="bankAccountsOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label-for="estimateDate" label="Percentual">
              <b-form-input
                v-model="purchase.payment"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="estimateDate" label="Valor a pagar">
              <b-form-input
                v-model="purchase.payment"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Condições">
              <b-form-select
                v-model="purchase.payment"
                :options="paymentConditionOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="estimateDate" label="Vencimento">
              <b-form-input
                v-model="purchase.payment"
                type="date"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-button
              variant="primary"
              class="mt-3"
              size="sm"
              @click="togglePanel"
            >
              Editar Parcelas
            </b-button>
          </b-col>
        </b-row>
        <SaleSidePanel
          :isPanelOpen="openPanel"
          :totalAmount="purchase"
          :installments="purchase"
          @close-saleSidepanel="togglePanel"
        ></SaleSidePanel>

        <b-row>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Desconto">
              <b-form-input
                v-model="purchase.payment"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Seguro">
              <b-form-input
                v-model="purchase.payment"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Outros gastos">
              <b-form-input
                v-model="purchase.payment"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <h3>Total da venda</h3>

        <b-row class="text-center">
          <b-col>
            <h5>Itens Orçamento</h5>
            <h4 style="color: #ffc600">
              R${{
                purchase.totalValue -
                  purchase.insurance -
                  (purchase.insurance + purchase.costs)
              }}
            </h4>
          </b-col>

          <span>-</span>

          <b-col>
            <h5>Desconto</h5>
            <h4 style="color: #9cff19">R${{ purchase.discount }}</h4>
          </b-col>

          <span>+</span>

          <b-col>
            <h5>Seguro</h5>
            <h4 style="color: #ffc600">R${{ purchase.insurance }}</h4>
          </b-col>

          <span>+</span>

          <b-col>
            <h5>Outros gastos</h5>
            <h4 style="color: #ffc600">
              R${{ purchase.insurance + purchase.costs }}
            </h4>
          </b-col>

          <span>=</span>

          <b-col>
            <h5>Valor Total</h5>
            <h4>R${{ purchase.totalValue }}</h4>
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col cols="12">
            <b-form-group label-for="notes" label="Observações">
              <b-form-textarea
                v-model="purchase.notes"
                id="notes"
                required
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <h3>Recorrências</h3>

        <b-row>
          <b-col cols="4">
            <b-form-group label="Tipo da recorrência">
              <b-form-select
                v-model="purchase"
                :options="recurrenceOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Intervalo">
              <b-form-input
                v-model="purchase"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Fim da recorrência">
              <b-form-input
                v-model="purchase"
                type="date"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-button type="submit" variant="primary">Cadastrar</b-button>
      </b-form>
    </div>

    <!-- ------------------------------------------------------------------------ -->

    <div v-if="menu.value == '2'">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col>
            <b-form-group label-for="code" label="Cód. Compra">
              <b-form-input
                v-model="purchase.code"
                type="text"
                id="code"
                required
              ></b-form-input> </b-form-group
          ></b-col>
          <b-col>
            <b-form-group label-for="code" label="Fornecedor">
              <b-form-select
                v-model="purchase.supplierId"
                :options="suppliers"
              ></b-form-select> </b-form-group
          ></b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label-for="code" label="Tipo da despesa">
              <b-form-input
                v-model="purchase.code"
                type="text"
                id="code"
                required
              ></b-form-input> </b-form-group
          ></b-col>
          <b-col>
            <b-form-group label-for="code" label="Data da compra">
              <b-form-input
                v-model="purchase.code"
                type="text"
                id="code"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <h3>Itens da venda</h3>

        <b-row>
          <b-col label-for="product" cols="12">
            <b-form-group label="Produto/Serviço">
              <b-form-input
                v-model="emptyPurchaseProduct.product.name"
                id="product"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="4">
            <b-form-group label="Quantidade">
              <b-form-input
                v-model.number="emptyPurchaseProduct.quantity"
                type="number"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Valor Unitário">
              <b-form-input
                v-model.number="emptyPurchaseProduct.purchasePrice"
                type="number"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Valor Total">
              <b-form-input
                v-model="emptyPurchaseProduct.total"
                type="text"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ag-theme-alpine-dark" style="height: 250px;">
            <ag-grid-vue
              style="width: 100%; height: 100%;"
              :columnDefs="columnDefs"
              :rowData="items"
              @grid-ready="onGridReady"
              @selection-changed="onSelectionChanged"
              @cell-value-changed="onCellValueChanged"
              :rowSelection="'multiple'"
              :defaultColDef="defaultColDef"
              rowHeight="40"
              :pagination="true"
            ></ag-grid-vue>
          </b-col>
        </b-row>
        <hr />
        <h3>Pagamento</h3>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Forma de pagamento">
              <b-form-select
                v-model="purchase.payment.paymentMethod"
                :options="paymentMethodsOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label-for="estimateDate" label="Valor a pagar">
              <b-form-input
                v-model="purchase"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Condições">
              <b-form-select
                v-model="purchase"
                :options="paymentConditionOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="estimateDate" label="Vencimento">
              <b-form-input
                v-model="purchase"
                type="date"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-button
              variant="primary"
              class="mt-3"
              size="sm"
              @click="togglePanel"
            >
              Editar Parcelas
            </b-button>
          </b-col>
        </b-row>
        <SaleSidePanel
          :isPanelOpen="openPanel"
          :totalAmount="purchase"
          :installments="purchase"
          @close-saleSidepanel="togglePanel"
        ></SaleSidePanel>

        <b-row>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Desconto">
              <b-form-input
                v-model="purchase"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Seguro">
              <b-form-input
                v-model="purchase"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="estimateDate" label="Outros gastos">
              <b-form-input
                v-model="purchase"
                type="number"
                id="estimateDate"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-button type="submit" variant="primary">Cadastrar</b-button>

        <fade-alert-danger
          ref="fadeAlertDanger"
          :msg="alert.error"
        ></fade-alert-danger>
        <success-fade-alert
          ref="successFadeAlert"
          :msg="alert.success"
        ></success-fade-alert>
      </b-form>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import BaseInputLogic from "@/components_rms/base/BaseImputLogic.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  name: "PurchaseCrud",
  components: {
    AgGridVue,
    BaseInputLogic,
    FadeAlertDanger,
    SuccessFadeAlert
  },
  data() {
    return {
      alert: {
        error: "Verifique os dados informados",
        success: "Compra cadastrada com sucesso!"
      },
      purchase: {
        id: null,
        purchaseHdId: null,
        supplierId: null,
        supplierName: "",
        code: "",
        date: new Date(Date.now()).toISOString().split("T")[0],
        costCenter: "",
        purchaseTypeId: 0,
        discount: 0.0,
        discountType: 1,
        insurance: 0.0,
        taxes: 0.0,
        costs: 0.0,
        totalValue: 0.0,
        notes: "",
        purchaseProducts: [],
        paymentId: null,
        payment: {
          id: null,
          paymentMethod: null,
          paymentTermsType: null,
          bankAccount: null,
          dueDate: "",
          installment: []
        },
        occurrenceType: 0,
        interval: 0,
        ocurranceEndDate: null
      },
      emptyPurchaseProduct: {
        id: null,
        purchaseId: null,
        productId: null,
        product: {
          id: null,
          name: ""
        },
        quantity: 1.0,
        purchasePrice: 0.0,
        discount: 0.0,
        get total() {
          return this.quantity * this.purchasePrice;
        }
      },
      installment: {
        id: null,
        dueDate: "",
        value: 0.0,
        percent: 0.0,
        observation: "",
        paymentId: null
      },
      recurrenceOptions: [
        { value: 1, text: "Dia" },
        { value: 1, text: "Mes" },
        { value: 1, text: "Ano" }
      ],
      discountTypeOptions: [
        { value: 0, text: "R$" },
        { value: 1, text: "%" }
      ],
      newPurchaseType: {
        name: "",
        code: 1,
        priority: 0
      },
      columnDefs: [
        {
          checkboxSelection: true,
          headerName: "Produto/Serviço",
          field: "product",
          sortable: true
        },
        {
          headerName: "Quantidade",
          field: "quantity",
          sortable: true
        },
        {
          headerName: "Valor Unitário",
          field: "unitPrice",
          sortable: true
        },
        { headerName: "Valor Total", field: "total", sortable: true }
      ],
      defaultColDef: {
        resizable: true,
        flex: 1
      },
      gridOptions: {
        onGridReady: this.onGridReady
      },
      suppliers: [],
      purchaseTypes: [ {value: "new", text: "Adicionar +"}],
      itens: [
        {
          label: "Produtos",
          options: [
            { value: "new", text: "Adicionar +" }
          ]
        },
        {
          label: "Serviços",
          options: [
            { value: "new", text: "Adicionar +" }
          ]
        }
      ],
      menu: {
        options: [
          { value: "1", text: "Compra" },
          { value: "2", text: "Compra simples" }
        ],
        value: "1"
      },
      isCollapsed: false
    };
  },
  watch: {
    'emptyPurchaseProduct.productId'(newVal) {
      const allOptions = this.itens.flatMap(group => group.options);
      const selected = allOptions.find(option => option.value === newVal);

      if (selected && selected.price != null) {
        this.emptyPurchaseProduct.purchasePrice = Number(selected.price);
      }
    },
    calculatedTotal(newTotal) {
      this.emptyPurchaseProduct.total = newTotal;
    }
  },
  mounted() {
    this.getAllSuppliers();
    this.getAllPurchaseType();
    this.getAllProducts();
    this.getAllServices()
  },
  computed: {
    calculatedTotal() {
      const { quantity, purchasePrice, discount } = this.emptyPurchaseProduct;
      const discountType = this.discountType;

      const q = Number(quantity) || 0;
      const p = Number(purchasePrice) || 0;
      let d = Number(discount) || 0;

      let total = q * p;

      if (discountType == '1') {
        d = (total * d) / 100;
      }

      total = total - d;
      return total.toFixed(2);
    }
  },
  methods: {
    getAllProducts(){
      this.$apiScheduler
        .get("/product/list")
        .then(response => {
          response.data.forEach(dataValue => {
            this.itens[0].options.push({value: dataValue.id, text: dataValue.code + "-" + dataValue.name, price: dataValue.price });
          })
          
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            callback([]);
          }
        });
    },
    getAllServices(){
      this.$apiScheduler
        .get("/service/list")
        .then(response => {
          response.data.forEach(dataValue => {
            this.itens[1].options.push({value: dataValue.id, text: dataValue.code + "-" + dataValue.name });
          })
          
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            callback([]);
          }
        });
    },
    getAllSuppliers() {
      this.$apiScheduler
        .get("/entity/suppliers")
        .then(response => {
          response.data.forEach(dataValue => {
            debugger;
            this.suppliers.push({
              value: dataValue.id,
              text: dataValue.fantasyName
                ? dataValue.fantasyName
                : dataValue.responsibleName
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAllPurchaseType() {
      this.$apiScheduler
        .get("/purchaseType/all")
        .then(response => {
          response.data.forEach(dataValue => {
            debugger;
            this.purchaseTypes.push({
              value: dataValue.id,
              text: dataValue.name
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    async addNewPurchaseType() {
      const response = await this.$apiScheduler.post(
        "/purchaseType/create",
        this.newPurchaseType
      );
      this.purchaseTypes.push({
        value: response.data.id,
        text: response.data.name
      });
      this.purchase.purchaseTypeId = response.data.id;
    },

    onRowClicked(event) {
      const rowData = event.data;
      this.$router.push({
        name: "EstimateCrud",
        query: rowData
      });
    },
    onSelectionChanged() {
      if (!this.gridApi) return;
      this.showDelete = this.gridApi.getSelectedNodes().length > 0;
      this.showEdit = this.gridApi.getSelectedNodes().length == 1;
    },
    onCellValueChanged(params) {
      if (
        params.column.colId === "quantity" ||
        params.column.colId === "unitPrice"
      ) {
        params.data.total = (
          params.data.quantity * params.data.unitPrice
        ).toFixed(2);
        this.updateTotals();
        this.gridApi.refreshCells({ force: true });
      }
    },
    togglePanel() {
      this.purchase.installments = this.generateInstallments(
        this.purchase.total.finalTotal,
        this.purchase.conditions,
        this.purchase.installmentValidity
      );
      this.openPanel = !this.openPanel;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
};
</script>
<style>
.ag-theme-alpine-dark .ag-root {
  background-color: #1e1e2f !important;
}

.ag-theme-alpine-dark .ag-header,
.ag-theme-alpine-dark .ag-header-cell-label {
  background-color: #1e1e2f;
  color: #ffffffb3 !important;
  font-family: "Poppins";
  font-size: 12px;
}
.ag-theme-alpine-dark {
  border: none !important;
  background-color: #1e1e2f !important;
}

.ag-theme-alpine-dark .ag-root-wrapper {
  background-color: #1e1e2f;
  border: none !important;
}
.ag-theme-alpine-dark .ag-row {
  background-color: #1e1e2f !important;
}
.top-menu {
  display: flex;
  gap: 10px;
}

.expandable-container {
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease-in-out; /* Animação suave */
}

.content-header {
  font-weight: bold;
}

.content-body {
  padding-top: 5px;
  font-size: 14px;
  transition: all 0.3s ease-in-out; /* Animação suave para o conteúdo */
  overflow: hidden; /* Evita "saltos" */
}
</style>
